import React from 'react';

import SpriteIcon from 'web/components/common/icon/SpriteIcon';

import classNames from 'classnames/bind';
import styles from './BackBtn.scss';
const cx = classNames.bind(styles);

const BackBtn = React.memo(({ className = [], onClick }) => {
  return (
    <button className={cx('BackBtn', ...className)} onClick={onClick}>
      <SpriteIcon name={`ic-login-back`} />
    </button>
  );
});

export default BackBtn;
